import { useAuth } from '../../context/DBContext';
import React, { useEffect, useState } from "react";
import './navbar.css';

const Navbar = () => {
    const { currentUser, logout, getUserInfo } = useAuth();
    const [error, setError] = useState();
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    async function handleLogout() {
        setError('');
        try {
            await logout();
            // history.push('/');
        } catch {
            setError('Failed to log out');
        }
    }

    useEffect(() => {
        if (currentUser) {
            getUserInfo(currentUser.uid).then((data) => {
                setUserInfo(data);
                setLoading(false);
            }).catch((error) => {
                setError('Failed to fetch user info');
                setLoading(false);
            });
        }
    }, [currentUser, getUserInfo]);

  return (
    <nav className="navbar">
                  <div className="col-12">        
            <div className="navbar-header">
                <a className="navbar-brand" href="/dashboard"><img src="/assets/img/logo.svg" width={30} /><span className="m-l-10">enableSEND</span></a>
            </div>
            
            {/* <ul className="nav navbar-nav navbar-left">
                <li><a href="javascript:void(0);" className="ls-toggle-btn" data-close="true"><i className="zmdi zmdi-swap" /></a></li>            
                <li className="hidden-sm-down">
                <div className="input-group">
                    <input type="text" className="form-control" placeholder="Search..." />
                    <span className="input-group-addon">
                    <i className="zmdi zmdi-search" />
                    </span>
                </div>
                </li>
            </ul> */}
            <ul className="nav navbar-nav navbar-right">

                {/* notification */}
                {/* <li className="dropdown"> <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button"><i className="zmdi zmdi-notifications" />
                    <div className="notify"><span className="heartbit" /><span className="point" /></div>
                </a>
                <ul className="dropdown-menu dropdown-menu-right slideDown">
                    <li className="header">NOTIFICATIONS</li>
                    <li className="body">
                    <ul className="menu list-unstyled">
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-blue"><i className="zmdi zmdi-account" /></div>
                            <div className="menu-info">
                            <h4>8 New Members joined</h4>
                            <p><i className="zmdi zmdi-time" /> 14 mins ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-amber"><i className="zmdi zmdi-shopping-cart" /></div>
                            <div className="menu-info">
                            <h4>4 Sales made</h4>
                            <p> <i className="zmdi zmdi-time" /> 22 mins ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-red"><i className="zmdi zmdi-delete" /></div>
                            <div className="menu-info">
                            <h4><b>Nancy Doe</b> Deleted account</h4>
                            <p> <i className="zmdi zmdi-time" /> 3 hours ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-green"><i className="zmdi zmdi-edit" /></div>
                            <div className="menu-info">
                            <h4><b>Nancy</b> Changed name</h4>
                            <p> <i className="zmdi zmdi-time" /> 2 hours ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-grey"><i className="zmdi zmdi-comment-text" /></div>
                            <div className="menu-info">
                            <h4><b>John</b> Commented your post</h4>
                            <p> <i className="zmdi zmdi-time" /> 4 hours ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-purple"><i className="zmdi zmdi-refresh" /></div>
                            <div className="menu-info">
                            <h4><b>John</b> Updated status</h4>
                            <p> <i className="zmdi zmdi-time" /> 3 hours ago </p>
                            </div>
                        </a> </li>
                        <li> <a href="javascript:void(0);">
                            <div className="icon-circle bg-light-blue"><i className="zmdi zmdi-settings" /></div>
                            <div className="menu-info">
                            <h4>Settings Updated</h4>
                            <p> <i className="zmdi zmdi-time" /> Yesterday </p>
                            </div>
                        </a>
                        </li>
                    </ul>
                    </li>
                    <li className="footer"> <a href="javascript:void(0);">View All Notifications</a> </li>
                </ul>
                </li> */}

                {/* flag */}
                {/* <li className="dropdown"> <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button"><i className="zmdi zmdi-flag" />
                    <div className="notify"><span className="heartbit" /><span className="point" /></div>
                </a>
                <ul className="dropdown-menu dropdown-menu-right slideDown">
                    <li className="header">TASKS</li>
                    <li className="body">
                    <ul className="menu tasks list-unstyled">
                        <li> <a href="javascript:void(0);">
                            <div className="progress-container progress-primary">
                            <span className="progress-badge">Footer display issue</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-warning" role="progressbar" aria-valuenow={86} aria-valuemin={0} aria-valuemax={100} style={{width: '86%'}}>
                                <span className="progress-value">86%</span>
                                </div>
                            </div>
                            </div>
                        </a>
                        </li>
                        <li> <a href="javascript:void(0);">
                            <div className="progress-container progress-info">
                            <span className="progress-badge">Answer GitHub questions</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-warning" role="progressbar" aria-valuenow={35} aria-valuemin={0} aria-valuemax={100} style={{width: '35%'}}>
                                <span className="progress-value">35%</span>
                                </div>
                            </div>
                            </div>
                        </a>
                        </li>
                        <li> <a href="javascript:void(0);">
                            <div className="progress-container progress-success">
                            <span className="progress-badge">Solve transition issue</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-warning" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} style={{width: '72%'}}>
                                <span className="progress-value">72%</span>
                                </div>
                            </div>
                            </div>
                        </a>
                        </li>
                        <li><a href="javascript:void(0);">
                            <div className="progress-container">
                            <span className="progress-badge"> Create new dashboard</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-warning" role="progressbar" aria-valuenow={45} aria-valuemin={0} aria-valuemax={100} style={{width: '45%'}}>
                                <span className="progress-value">45%</span>
                                </div>
                            </div>
                            </div>
                        </a>
                        </li>
                        <li> <a href="javascript:void(0);">
                            <div className="progress-container progress-warning">
                            <span className="progress-badge">Panding Project</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-warning" role="progressbar" aria-valuenow={29} aria-valuemin={0} aria-valuemax={100} style={{width: '29%'}}>
                                <span className="progress-value">29%</span>
                                </div>
                            </div>
                            </div>
                        </a>
                        </li>
                    </ul>
                    </li>
                    <li className="footer"><a href="javascript:void(0);">View All</a></li>
                </ul>
                </li> */}

                {/* fullscreen */}
                {/* <li>
                <a href="javascript:void(0);" className="fullscreen hidden-sm-down" data-provide="fullscreen" data-close="true"><i className="zmdi zmdi-fullscreen" /></a>
                </li> */}

                <li><a href="" onClick={handleLogout}  title="Sign out" className="mega-menu" data-close="true"><i className="zmdi zmdi-power" /></a></li>
               
                <li className><a href="javascript:void(0);" className="js-right-sidebar" data-close="true"><i className="zmdi zmdi-settings zmdi-hc-spin" /></a></li>
            </ul>
            </div>
    </nav>
  );
};

export default Navbar;
